/**
 * Vuex actions for the "restrict" module.
 *
 * Wraps API calls for restricting replies on a post and for fetching the
 * restrict list, committing the results via updates.js mutations.
 */
export default {
  /** PATCH a post with `updatedData` to restrict/unrestrict its replies, then commit SET_RESTRICT_ON_REPLIES with the updated post's id. */
  async restrictUserOnReplies({ commit }, payload) {
    try {
      const { id, updatedData } = payload;

      const response = await fetch(`/api/posts/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedData),
      });

      if (!response.ok) {
        console.error(
          `Failed to update post with ID ${id}: ${response.statusText}`
        );
      }

      const data = await response.json();
      commit("SET_RESTRICT_ON_REPLIES", data.id);
      return data;
    } catch (error) {
      console.error("Error updating post:", error);
      throw error;
    }
  },

  /** Fetch the restrict list from the API service and commit it via `setRestrictList`. */
  async getRestrictList({ commit }, payload) {
    try {
      const res = await this.$api.restrict.getRestrictList(payload);
      commit("setRestrictList", res.data);
    } catch (error) {
      // console.log(error);
    }
  },
};
